
<div *ngFor="let d of dataTxt">
    <p class="txt-{{d.TipoDetalle}}" *ngIf="d.TipoDetalle=='descripcion' || d.TipoDetalle=='subtitle' || d.TipoDetalle=='subdescripcion'" > {{ d.Descripcion }} </p>
</div>
